import type { KeyOfType } from '@/types'

export default function indexBy<
  T extends Record<string, unknown>,
  K extends KeyOfType<T, PropertyKey>
>(items: T[] | ReadonlyArray<T>, field: K): Map<T[K], T> {
  const map = new Map<T[K], T>()
  for (const item of items) {
    map.set(item[field], item)
  }
  return map
}
